import type { StaticPricingTierFormValue } from './_static-pricing-tiers-form-list';

export function getLowerBound(
  tiers: StaticPricingTierFormValue[],
  index: number
): number | null {
  if (index === 0) return 0;
  return tiers[index - 1]?.fillRateThreshold ?? null;
}

export function calcFillRateThresholdMinValue(
  isFirst: boolean,
  fieldCount: number,
  lowerBound: number | null | undefined
): number {
  if (!isFirst) return (lowerBound ?? 0) + 1;
  return fieldCount > 1 ? 1 : 0;
}

export function validateStaticTiers(
  tiers: StaticPricingTierFormValue[]
): string | null {
  if (!tiers || tiers.length < 1)
    return 'At least one pricing tier is required';
  if (tiers.length > 10) return 'Maximum 10 tiers allowed';

  const lastTier = tiers[tiers.length - 1];
  if (lastTier?.fillRateThreshold !== 100)
    return 'Final tier must end at 100%.';

  const payRates = new Set<number>();

  for (const [i, tier] of tiers.entries()) {
    const currentUpper = tier?.fillRateThreshold;
    if (currentUpper === null || currentUpper === undefined) continue;

    if (currentUpper < 0 || currentUpper > 100)
      return 'Fill rate upper bounds must be 0-100.';

    const lowerBound = i === 0 ? 0 : tiers[i - 1]?.fillRateThreshold;
    if (
      lowerBound !== null &&
      lowerBound !== undefined &&
      currentUpper <= lowerBound
    )
      return 'Each tier upper bound must be greater than its lower bound.';

    if (typeof tier.payRate !== 'number') continue;

    if (payRates.has(tier.payRate))
      return 'Different fill rate tiers may not have the same pay rate.';

    payRates.add(tier.payRate);
  }

  return null;
}
